module.exports = __webpack_public_path__ + "c115dfb3fb5f539e6558a114905734b4.svg";